import { Tag } from "../global-commons/type";
class DataBlock {
  data: any; // デコードされたデータブロックの内容
  constructor() {
    const dataBlock = document.getElementById("data-block");
    if (!dataBlock) {
      console.error("data-block not found");
      return;
    }
    this.data = JSON.parse(dataBlock.innerText);
  }
  getSelectableTagCategoryInMap(): number {
    return this.data.selectableTagCategoryInMap;
  }
  // 「ここで使えるチケットを検索」ボタンの有無を取得するメソッド
  getEnableSearchAvailableTickets(): boolean {
    return this.data.enableSearchAvailableTickets ?? true;
  }
  getEnv(): {
    INTEREST_TAG_CATEGORY_ID: number;
    SEARCH_API_URL: string;
    API_URL: string;
  } {
    return this.data.env;
  }
  getI18n(): { [key: string]: string } {
    return this.data.i18n;
  }
  getMapStyleUrl(): string {
    return this.data.mapStyleUrl;
  }
}
export const DATA_BLOCK = new DataBlock();
